const escapeHtml = (str: string) => {
    // Use the browser's built-in functionality to quickly and safely escape the string
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
};

const escapeJs = (str: string) => str.replace(/[^\0-~]/g, c => '\\u' + ('000' + c.charCodeAt(0).toString(16)).slice(-4));
const escapeLink = (str: string) => decodeURIComponent(str).split('/').map(s => encodeURI(s)).join('/');
const protocolRegEx = /^([a-z0-9]+):\/\//i;
const escapeCompleteHref = (link) => link.match(protocolRegEx)[1]?.indexOf('script') === -1 ? new URL(link).toString() : '';

export const escapeAll = (str: string) => escapeHtml(escapeJs(str));

/*
 * Currently, three cases exists :
 * - external: start with a url scheme "[a-z]://" shoud be a valid url, no interpretation
 * - absolute: start with a single / point to absolute path on local UI server (eg: /content/help/logo.png)
 * - relative link : everything else, point to current application content folder on API URL
 * Content of URL are escaped to prevent XSS.
 */
export const relativeUrl = (href: string, apiUrl: string, appUrl: string) => {
    const hasHref = (href && href.length);
    const isExternal = hasHref && protocolRegEx.test(href);
    const isAbsolute = hasHref && href[0] === '/';

    const link = isExternal
        ? escapeCompleteHref(href)
        : isAbsolute
            ? `${escapeLink(href)}`
            : `${apiUrl}content/${appUrl}/${escapeLink(href)}`;

    return escapeHtml(link);
};

export const fromAbsoluteUrl = (href: string, apiUrl: string, appUrl: string) => {
    const link = href.replace(`${apiUrl}content/${appUrl}/`, '');
    return link;
};